<template lang="pug">
  .page
    section
      .max-width


        AlertBox(type="danger", text="Oh no! Your trial has expired :-(")

</template>

<script>

import LottieAnimation from '@/components/helpers/LottieAnimation'

export default {
  name: 'Expired',
  components: {
    LottieAnimation
  },
  beforeMount () {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
  .animation
    +for_breakpoint(mobile)
      display none

</style>
